import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyType } from '../api/types';

const useBodyTypeDescription = () => {
    const { t } = useTranslation('common');

    return useCallback(
        (bodyType: BodyType) => {
            switch (bodyType) {
                case BodyType.Coupe:
                    return t('common:options.bodyTypes.coupe');

                case BodyType.Convertible:
                    return t('common:options.bodyTypes.convertible');

                case BodyType.Hatchback:
                    return t('common:options.bodyTypes.hatchback');

                case BodyType.Mpv:
                    return t('common:options.bodyTypes.mpv');

                case BodyType.Suv:
                    return t('common:options.bodyTypes.suv');

                case BodyType.Sedan:
                    return t('common:options.bodyTypes.sedan');

                case BodyType.Van:
                    return t('common:options.bodyTypes.van');

                case BodyType.Wagon:
                    return t('common:options.bodyTypes.wagon');

                default:
                    throw new Error('Invalid body type');
            }
        },
        [t]
    );
};

export default useBodyTypeDescription;
